/* eslint-disable @typescript-eslint/semi */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/consistent-type-imports */
/* eslint-disable @typescript-eslint/space-before-function-paren */
/* eslint-disable @typescript-eslint/comma-dangle */
/* eslint-disable @typescript-eslint/prefer-readonly */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/consistent-generic-constructors */
/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/no-base-to-string */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  type WebSocketMessage,
  type DashboardRequest,
  WebSocketStatus,
  type TypedWebSocketMessage,
  type WebSocketMessageType,
  type DashboardModbusDataUpdate,
  type DashboardKPIDataUpdate,
  type DashboardDeviceStatusUpdate,
  type AssetDashboardRequest
} from '../types/websocket.types'
import { getAuthToken } from '../utils/authUtils'

// Generate a random UUID for correlation IDs
const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

// WebSocket service options
export interface WebSocketServiceOptions {
  url: string
  tenantId: string
  username: string
  authToken?: string // Optional JWT token for subprotocol authentication
  reconnectAttempts?: number
  reconnectInterval?: number
  onOpen?: () => void
  onClose?: (event: CloseEvent) => void
  onError?: (error: Event) => void
  onMessage?: (message: WebSocketMessage) => void
  onStatusChange?: (status: WebSocketStatus) => void
}

export interface KPIPayloadType {
  devices?: any[] // Device ID to KPI definition ID mapping
  assets?: any[] // Asset ID to KPI definition ID mapping
}

export class WebSocketService {
  private socket: WebSocket | null = null
  private readonly options: WebSocketServiceOptions
  private reconnectAttempts = 0
  private reconnectTimer: ReturnType<typeof setTimeout> | null = null
  private readonly messageCallbacks = new Map<string, (message: WebSocketMessage) => void>()
  private status: WebSocketStatus = WebSocketStatus.DISCONNECTED
  private maxRetriesReached = false // Track if max retries have been reached

  constructor (options: WebSocketServiceOptions) {
    this.options = {
      reconnectAttempts: 2,
      reconnectInterval: 3000,
      ...options
    }
  }

  /**
   * Connect to the WebSocket server with authentication via query parameters
   */
  public connect (): void {
    // Don't attempt to connect if max retries have been reached
    if (this.maxRetriesReached) {
      return
    }

    if (this.socket != null && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
      return
    }

    this.setStatus(WebSocketStatus.CONNECTING)

    try {
      // Add authentication parameters to the URL
      const url = new URL(this.options.url)
      url.searchParams.append('tenantId', this.options.tenantId)
      url.searchParams.append('username', this.options.username)

      // Get authentication token and set up subprotocols
      const authToken = this.options.authToken || getAuthToken()
      const protocols = authToken ? [`authorization.bearer.${authToken}`] : []

      // Create WebSocket connection with the modified URL
      this.socket = new WebSocket(url.toString(), protocols)
      this.socket.onopen = this.handleOpen.bind(this)
      this.socket.onclose = this.handleClose.bind(this)
      this.socket.onerror = this.handleError.bind(this)
      this.socket.onmessage = this.handleMessage.bind(this)
    } catch (error) {
      this.setStatus(WebSocketStatus.ERROR)
      this.attemptReconnect()
    }
  }

  /**
   * Disconnect from the WebSocket server
   */
  public disconnect(): void {
    if (this.socket) {
      this.socket.close()
      this.socket = null

      if (this.reconnectTimer !== null) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }

      this.reconnectAttempts = 0;
      this.maxRetriesReached = false; // Reset max retries flag
      this.setStatus(WebSocketStatus.DISCONNECTED);
    }
  }

  /**
   * Subscribe to device updates
   */
  public subscribeToDevice(deviceId: string): Promise<WebSocketMessage> {
    const correlationId = generateUUID();

    const dashboardRequest: DashboardRequest = {
      deviceId,
      tenantId: this.options.tenantId,
      username: this.options.username,
    };

    const message: WebSocketMessage = {
      type: 'DASHBOARD_MODBUS_DATA_SUBSCRIBE',
      data: dashboardRequest,
      correlationId,
    };

    return this.sendMessage(message);
  }

  /**
   * Subscribe to device KPI updates
   */
  public subscribeToDeviceKPIs(deviceId: string): Promise<WebSocketMessage> {
    const correlationId = generateUUID();

    const dashboardRequest: DashboardRequest = {
      deviceId,
      tenantId: this.options.tenantId,
      username: this.options.username,
    };

    const message: WebSocketMessage = {
      type: 'DASHBOARD_KPI_DATA_SUBSCRIBE',
      data: dashboardRequest,
      correlationId,
    };

    return this.sendMessage(message);
  }

  /**
   * Subscribe to device alarm updates
   */
  public subscribeToDeviceAlarms(deviceId: string): Promise<WebSocketMessage> {
    const correlationId = generateUUID();

    const dashboardRequest: DashboardRequest = {
      deviceId,
      tenantId: this.options.tenantId,
      username: this.options.username,
    };

    const message: WebSocketMessage = {
      type: 'DASHBOARD_ALARM_DATA_SUBSCRIBE',
      data: dashboardRequest,
      correlationId,
    };

    return this.sendMessage(message);
  }

  public subscribeToAssetModBus(modBusPayload: object): Promise<WebSocketMessage> {
    const correlationId = generateUUID();
    const dashboardRequest: AssetDashboardRequest = {
      tenantId: this.options.tenantId,
      username: this.options.username,
      devices: modBusPayload,
    };
    const message: WebSocketMessage = {
      type: 'DASHBOARD_MODBUS_DATA_SUBSCRIBE',
      data: dashboardRequest,
      correlationId,
    };

    return this.sendMessage(message);
  }

  public subscribeToAssetKPIs(KPIPayload: KPIPayloadType): Promise<WebSocketMessage> {
    const correlationId = generateUUID();
    const dashboardRequest: AssetDashboardRequest = {
      tenantId: this.options.tenantId,
      username: this.options.username,
      devices: KPIPayload.devices,
      assets: KPIPayload.assets
    };

    const message: WebSocketMessage = {
      type: 'DASHBOARD_KPI_DATA_SUBSCRIBE',
      data: dashboardRequest,
      correlationId,
    };

    return this.sendMessage(message);
  }

  /**
   * Subscribe to device status updates
   */
  public subscribeToDeviceStatus(deviceId: string): Promise<WebSocketMessage> {
    const correlationId = generateUUID();

    const dashboardRequest: DashboardRequest = {
      deviceId,
      tenantId: this.options.tenantId,
      username: this.options.username,
    };

    const message: WebSocketMessage = {
      type: 'DASHBOARD_DEVICE_STATUS_SUBSCRIBE',
      data: dashboardRequest,
      correlationId,
    };

    return this.sendMessage(message);
  }

  /**
   * Subscribe to Active Alert Duration status updates
   */
  public subscribeToAlertDurationStatus(deviceId: string): Promise<WebSocketMessage> {
    const correlationId = generateUUID();

    const dashboardRequest: DashboardRequest = {
      deviceId,
      tenantId: this.options.tenantId,
      username: this.options.username,
    };

    const message: WebSocketMessage = {
      type: 'DASHBOARD_ACTIVE_ALERT_COUNT_SUBSCRIBE',
      data: dashboardRequest,
      correlationId,
    };

    return this.sendMessage(message);
  }

  /**
   * Send a message to the WebSocket server with a promise response
   */
  public sendMessage(message: WebSocketMessage): Promise<WebSocketMessage> {
    if (!this.isConnected()) {
      return Promise.reject(new Error('WebSocket is not connected'));
    }

    const correlationId = message.correlationId || generateUUID();
    message.correlationId = correlationId;

    return new Promise((resolve, reject) => {
      // Set up a callback to handle the response with this correlationId
      const timeoutId = setTimeout(() => {
        this.messageCallbacks.delete(correlationId);
        reject(new Error('WebSocket request timed out'));
      }, 30000); // 30-second timeout

      this.messageCallbacks.set(correlationId, (response: WebSocketMessage) => {
        clearTimeout(timeoutId);
        this.messageCallbacks.delete(correlationId);

        if (response.error) {
          reject(new Error(response.error));
        } else {
          resolve(response);
        }
      });

      // Send the message
      this.socket?.send(JSON.stringify(message));
    });
  }

  /**
   * Check if the WebSocket is connected
   */
  public isConnected(): boolean {
    return this.socket !== null && this.socket.readyState === WebSocket.OPEN;
  }

  /**
   * Get the current WebSocket status
   */
  public getStatus(): WebSocketStatus {
    return this.status;
  }

  /**
   * Handle WebSocket open event
   */
  private handleOpen(event: Event): void {
    this.reconnectAttempts = 0;
    this.maxRetriesReached = false; // Reset max retries flag on successful connection
    this.setStatus(WebSocketStatus.CONNECTED);

    // Notify that the connection is established
    if (this.options.onOpen) {
      this.options.onOpen();
    }
  }

  /**
   * Handle WebSocket close event
   */
  private handleClose(event: CloseEvent): void {
    this.socket = null;
    this.setStatus(WebSocketStatus.DISCONNECTED);

    if (this.options.onClose) {
      this.options.onClose(event);
    }

    // Only attempt to reconnect if this was not a clean close and max retries not reached
    if (!event.wasClean && !this.maxRetriesReached) {
      this.attemptReconnect();
    }
  }

  /**
   * Handle WebSocket error event
   */
  private handleError(event: Event): void {
    // Only log error once to avoid spam
    if (this.reconnectAttempts === 0) {
      console.error('WebSocket connection failed');
    }
    this.setStatus(WebSocketStatus.ERROR);

    if (this.options.onError) {
      this.options.onError(event);
    }

    // Don't attempt reconnect if max retries reached
    if (!this.maxRetriesReached) {
      this.attemptReconnect();
    }
  }

  /**
   * Handle WebSocket message event
   */
  private handleMessage(event: MessageEvent): void {
    try {
      const message: WebSocketMessage = JSON.parse(event.data);

      // Check if there's a callback registered for this correlation ID
      if (message.correlationId && this.messageCallbacks.has(message.correlationId)) {
        const callback = this.messageCallbacks.get(message.correlationId);
        if (callback) {
          callback(message);
        }
      }

      // Always call the general onMessage handler if provided
      if (this.options.onMessage) {
        this.options.onMessage(message);
      }
    } catch (error) {
      console.error('Error parsing WebSocket message:', error);
    }
  }

  /**
   * Attempt to reconnect to the WebSocket server
   */
  private attemptReconnect(): void {
    const maxReconnectAttempts = this.options.reconnectAttempts || 2;
    const reconnectInterval = this.options.reconnectInterval || 3000;

    if (this.reconnectAttempts < maxReconnectAttempts && !this.maxRetriesReached) {
      this.reconnectAttempts++;

      if (this.reconnectTimer !== null) {
        clearTimeout(this.reconnectTimer);
      }

      this.reconnectTimer = setTimeout(() => {
        this.connect();
      }, reconnectInterval);
    } else {
      // Mark that max retries have been reached
      this.maxRetriesReached = true;
      this.setStatus(WebSocketStatus.DISCONNECTED);

      // Clear any pending reconnection attempts
      if (this.reconnectTimer !== null) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    }
  }

  /**
   * Set the WebSocket status and trigger the onStatusChange callback
   */
  private setStatus(status: WebSocketStatus): void {
    this.status = status;

    if (this.options.onStatusChange) {
      this.options.onStatusChange(status);
    }
  }
}

export default WebSocketService;
